import { render, staticRenderFns } from "./curriculumName.vue?vue&type=template&id=749841a4&scoped=true"
import script from "./curriculumName.vue?vue&type=script&lang=js"
export * from "./curriculumName.vue?vue&type=script&lang=js"
import style0 from "./curriculumName.vue?vue&type=style&index=0&id=749841a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749841a4",
  null
  
)

export default component.exports